import script from "./instructor-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./instructor-settings.vue?vue&type=script&setup=true&lang=js"

import "./instructor-settings.vue?vue&type=style&index=0&id=32021f2e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32021f2e"]])

export default __exports__